

/*
	Source: htdocs/wim/js/core/src/PageNavigation.js
*/
(function($, wimbledonCore) {
/**
     *  Poller Class
     *      Used for setting up repeating AJAX loads. Supports
     *      a variety of options ranging from simple to complex.
     */
    function PageNavigation() {
        var id = 'PageNavigation';
        var logger = new eventsCore.util.Logger(id);

        var _types = {
            scroll: 1,
            generic: 2
        };

        var _defaults = {
            page: 'scroll',
            ignore: '', // comma separated list of jQuery selectors defining containers within which clicks should be ignored

            triggers: [], // array of anonymous functions setting up listeners to track user interactions to reinstate
            handlers: [] // array of anonymous functions to reapply saved states
        };

        var waypointScroll = false;
        var waypointHash = '';

        /**
         * setup waypoint listeners
         * - sets up handlers based on anchors identified in an option list
         */
        var setupWaypoints = function(anchors) {
            if (typeof $('#' + topDiv).waypoint === 'undefined') {
                logger.error('setupWaypoints - waypoints not available (jquery.waypoints.min.js)');
                return;
            }

            waypointHash = '';

            $('#' + anchors).each(function(){
                //logger.info('options - %o', $(this).val());
                if($(this).val() !== '#' + topDiv) {
                    $($(this).val()).waypoint({
                        handler: function(direction) {
                            if (waypointScroll) {
                                //logger.info('waypoint - elem:%o dir:%o scroll:%o', this.element.id, direction, waypointScroll);
                                //window.location.hash = 'nav' + this.element.id;
                                waypointHash = 'nav' + this.element.id;
                            }
                            else {
                                waypointScroll = true;
                            }
                        },
                        offset: 20,
                        continuous: false,
                        context: document.getElementById(topDiv)
                    });
                }
            });
        };



        /**
         * implement position based back navigation
          */
        var initPositionNav = function(options) {
            _.defaults(options, _defaults);

            var selector = 'body';
            var eventNode = '.childScroll';
            var pageType = _types[options.page];
            if(pageType === _types.generic) {
                eventNode = selector = '.genericMain';
            }

            /**
             * wrapper function to add hash element to URL
             * @param  {object} object key value pair containing key and value to process
             */
            var pushState = function(object) {
                if(!!(window.history && window.history.pushState)) {
                    history.replaceState(object, '', $.param.fragment('', object));
                } else {
                    $.bbq.pushState(object);
                }
            }

            $(document).ready(function(){
                var hash = $.deparam.fragment();
                //logger.info('ready - hash:%o', hash);

                /* triggers */
                // default page position
                $(eventNode).on('click', 'a', function(e){
                    // e.preventDefault();
                    var ignoredContainer = $(this).closest(options.ignore);
                    // logger.info('initPositionNav-click - hash:%o', navPar);
                    if (ignoredContainer.length == 0) {
                        var frag = {};

                        // loop through custom function calls
                        var calls = [];
                        for(var i=0,l=options.triggers.length;i<l;i++) {
                            calls.push(options.triggers[i].call(this));
                        }
                        frag = _.extend.apply(this, _.flatten([frag, calls]));

                        // record positions for generic pages only
                        // because that is internally scrolled
                        if(pageType === _types.generic) {
                            var top = $(selector).scrollTop();
                            if(top > 0) {
                                frag.nav = top;
                            }
                        }

                        pushState(frag);
                    }
                });


                if(hash) {
                    /* handlers */

                    // array to store Promise states
                    var states = [];

                    /**
                     * Sample handler function with AJAX principles
                     * function(hash) {
                     *     var d = $.Deferred();
                     *
                     *     function setRound() {
                     *         if(hash.ref && $('.navsect[data-ref="' + hash.ref + '"]').length > 0) {
                     *             history_set_round(hash.ref);
                     *         }
                     *
                     *         d.resolve();
                     *     }
                     *
                     *     var navsect = $('.navsect');
                     *     if(navsect.length === 0) {
                     *         $(window).on('customevent', setRound);
                     *     } else {
                     *         setRound();
                     *     }
                     *
                     *     return d;
                     * }
                     */

                    // loop through custom function calls
                    for(var j=0,l=options.handlers.length;j<l;j++) {
                        // each handler function should return a Promise object
                        // set to resolved when the action is complete
                        states.push(options.handlers[j].call(this, hash));
                    }

                    // when all Promise objects are resolved (or failed)
                    // then execut the default page position handler
                    $.when.apply($, states).always(function() {
                        if(hash.nav) {
                            // default page position
                            var pos = parseInt(hash.nav);
                            if(pos > 0) {
                                logger.info('ready - pos:%o', pos);
                                $(selector).animate({
                                    scrollTop: pos
                                });
                            }
                        }
                    })
                }
            });
        };

        /**
         * watch for 'navB' style navigation identifier on page load and scroll to the related anchor
         * - call setup for waypoint listeners in page
         * @topDiv  selector for the top div which contains scrolling elements
         * @anchors selector for the option tags which contain anchor name
         */
        var initWaypointNav = function(topDiv, anchors) {
            $(document).ready(function(){
                var hash = window.location.hash;
                //logger.info('ready - hash:%o', hash);

                $("a").click(function(){
                    window.location.hash = waypointHash;
                    return true;
                });

                if(hash) {
                    var elem = $('#' + hash.replace('#nav', ''));
                    //logger.info('ready - pos:%o', pos);
                    $('#' + topDiv).animate({
                            scrollTop: (elem.position().top)
                        }, function(){
                            setupWaypoints(topDiv, anchors);
                        });
                }
                else {
                    setupWaypoints(topDiv, anchors);
                }
            });
        };

        return {
            initWaypointNav: initWaypointNav,
            initPositionNav: initPositionNav

        };
    };

    wimbledonCore.pageNavigation = new PageNavigation();

}(jQuery, window.wimbledonCore));